import instance from "@/utils/require.js"

// SN管理--分页查询
export function apiDeviceSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/device/search",
		method: "post",
		data
	})
}
// SN管理--分页查询
export function apiPcbaSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/pcba/search",
		method: "post",
		data
	})
}


export function apiAddNotes(data = {}) {
	return instance({
		url: "aim/api/v3/device/add_notes",
		method: "post",
		data
	})
}

// SN管理--产品类别列表
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// SN管理--产品型号列表
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// SN管理--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// SN管理--当前工序
export function apiWorkStations(data = {}) {
	return instance({
		url: "aim/api/v3/enum/work_stations",
		method: "post",
		data
	})
}

// SN管理--产品进程列表
// export function apiDeviceProcess(data = {}) {
// 	return instance({
// 		url: "/aim/api/v3/enum/device_process",
// 		method: "post",
// 		data
// 	})
// }

// SN改制--更新产品型号
export function apiUpdateProductModel(data = {}) {
	return instance({
		url: "/aim/api/v3/device/update_product_model",
		method: "post",
		data
	})
}